import { giphyDarkestGrey, giphyLightGrey } from '@giphy/colors'
import styled from 'styled-components'
import { Avatar as AvatarComponent, IconButton } from 'ui'

export const Container = styled.div`
    background: ${giphyDarkestGrey};
    box-sizing: border-box;
    display: flex;
    height: 58px;
    padding: 12px;
    width: 100%;
`

export const Avatar = styled(AvatarComponent)`
    border-radius: 2px;
    flex-shrink: 0;
    height: 34px;
    margin-right: 12px;
    width: 34px;
`

export const SearchButton = styled(IconButton)`
    flex-shrink: 0;
`

export const Username = styled.div`
    display: flex;
    flex-direction: column;
    font-weight: bold;
    height: 100%;
    justify-content: center;
    line-height: 1;
    margin: 0 12px 0 0;
    overflow: hidden;
    text-align: left;
    width: 100%;

    h3 {
        color: #fff;
        font-size: 1em;
        margin: 0;
        overflow: hidden;
        padding: 0;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    span {
        color: ${giphyLightGrey};
        display: block;
        font-size: 0.6em;
        margin-bottom: 0.3em;
    }
`
